import {inject, Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot} from "@angular/router";
import {Observable, tap} from "rxjs";
import {ECampaign} from "../../../core/business-logic/campaign/entity/e.campaign";
import {CampaignRepository} from "../../../api/campaign/campaign.repository";

@Injectable({providedIn: 'root'})
export class CampaignResolver implements Resolve<ECampaign> {
  private readonly router = inject(Router);
  private readonly campaignRepository = inject(CampaignRepository);

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<ECampaign> | Promise<ECampaign> | ECampaign {
    const {slug} = route.params;
    if (!slug) {
      this.router.navigate(['/']);
    }
    return this.campaignRepository.findOneBySlug(slug).pipe(
      tap((campaign) => {
        if (!campaign) {
          this.router.navigate(['/']);
        }
      }),
    );
  }
}
